import React, { Component } from "react";
import ReeValidate from 'ree-validate'
import { injectStripe } from 'react-stripe-elements';
import { connect } from "react-redux";
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { updateBrandSubscription } from "../../store/actions/payments"
import { showAlert } from '../../store/actions/alert';
import ButtonContent from '../ButtonContent';
import Button from '@material-ui/core/Button';
import Card from './../../modals/card'

class MakePayment extends Component {

  constructor(props) {
    super(props);

    this.validator = new ReeValidate({
      cardHolderName: 'required|min:5',
    });

    this.state = {
      show: props.show,
      cardHolderName: '',
      formErrors: this.validator.errors,
      isSubmit: false
    };
    this.paymentCard = React.createRef();
  }

  handleSubmit = e => {
    e.preventDefault();
    this.paymentCard.current.getWrappedInstance().handleSubmit()
    const paymentCardInstance = this.paymentCard.current.getWrappedInstance();
    const { isCardError, cardHolderName } = paymentCardInstance.state;
    setTimeout(() => {
      if (isCardError) {
        this.setState({
          isSubmit: true,
        });
      this.createNonce(cardHolderName);
      }
    },100);
  };

  async createNonce(cardHolderName) {

    const { updateSubscription, planOption } = this.props;
    const { showAlert } = this.props;
    const res = await this.props.stripe.createToken({ name: cardHolderName });
    if (res.error) {
      const message = res.error.message;
      showAlert(message, true);
      this.setState({
        isSubmit: false,
      });
    } else {
      const token = res.token;
      updateSubscription({
        token: token.id,
        planOption: planOption
      }).then((response) => {
          this.setState({
              show: false,
              isSubmit: false
          }, () => {
              this.props.hidePaymentMethod();
              window.location.reload();
          });
      });
    }
  }

  handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    const { errors } = this.validator;
    errors.remove(name);
    this.setState({ cardHolderName: value });
    this.validator.validate(name, value).then(() => {
      this.setState({ formErrors: errors });
    });
  };

  render() {

    return (
      <div>
        <Dialog
          open={this.state.show}
          onClose={() => this.setState({ show: false }, () => {
            this.props.hidePaymentMethod()
          })}
        >
          <DialogTitle>
            Make Payment
          </DialogTitle>
          <DialogContent style={{width: 400}}>
           <Card  ref={this.paymentCard}  brandIcon="brand-follow-existing-user-icon"></Card>
            <div style={{marginTop: 10, float: 'right'}}>
            <Button
              color='primary'
              variant="contained"
              disabled={this.state.isSubmit}
              onClick = {this.handleSubmit}
            >
              <ButtonContent
                text={ "Done"}
              />
            </Button>
           </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
    return {
      paymentToken: state.payments.token
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      updateSubscription: (card) => {
            return dispatch(updateBrandSubscription(card));
        },
        showAlert: (message, isError) => {
          return dispatch(showAlert(message, isError));
        }
    }
  }

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(injectStripe(MakePayment));



// WEBPACK FOOTER //
// ./src/components/membershipPlan/makePayment.js